import { render, staticRenderFns } from "./skus-table.vue?vue&type=template&id=d8f1b15e&scoped=true"
import script from "./skus-table.vue?vue&type=script&lang=js"
export * from "./skus-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8f1b15e",
  null
  
)

export default component.exports